export default __webpack_public_path__ + "static/ai-banner2-63a2bfbe179d2ee416baab343a98bf03.jpg";